import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit
} from '@angular/core';
import { locale } from './chart-layout.locale';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  takeUntil
} from 'rxjs/operators';
import { Destroyer } from 'app/common/utils';
import { ChartsCommonService } from '../../services/charts-common.service';
import { ChartsDashboardQuery } from '../../state/dashboard';
import { ICard } from '../../state/card';
import {
  ICardAreaSettings,
  ILayoutEntity,
  ILayoutSettings,
  LayoutType
} from '../../interfaces';
import { ID } from '@datorama/akita';
import { Observable } from 'rxjs';
import { IChartSeries } from '../../state/series';

@Component({
  selector: 'iv-live-charts-layout',
  templateUrl: './charts-layout.component.html',
  styleUrls: ['./charts-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartsLayoutComponent extends Destroyer implements OnInit, OnDestroy {

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly elementRef: ElementRef,
    private readonly chartsCommonService: ChartsCommonService,
    private readonly dashboardQuery: ChartsDashboardQuery
  ) {
    super();
  }

  public $cardIds: Observable<ID[]> = this.dashboardQuery.selectDashboardCards()
  .pipe(
    map((cards: ICard<IChartSeries>[]) => cards.map((card: ICard<IChartSeries>) => card.id)),
    distinctUntilChanged((prev: ID[], curr: ID[]) => {
      return !prev.filter(x => curr.includes(x)).length;
    })
  );
  public cards: ICard<ID>[] = [];
  public locale = locale;
  public isLoading: boolean;

  public ngOnInit(): void {
    this.layoutSubscription();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private layoutSubscription(): void {
    this.dashboardQuery.selectDashboardLayout()
      .pipe(
        debounceTime(1),
        takeUntil(this.destroy$)
      )
      .subscribe((layout: ILayoutEntity) => {
        this.cleanGridSettings();
        this.setGridSettings(this.chartsCommonService.convertLayoutToGridSettings(layout));
      });
  }

  private setGridSettings(settings: ILayoutSettings): void {
    this.elementRef.nativeElement.style.setProperty('--columns-settings', settings.columnsSettings);
    this.elementRef.nativeElement.style.setProperty('--row-settings', settings.rowsSettings);

    this.changeDetectorRef.detectChanges();

    if (settings.layoutType === LayoutType.DEFAULT) return;

    for (let i = 0; i < this.elementRef.nativeElement.children.length; i++) {
      if (settings.cardsAreaSettings.length) {
        settings.cardsAreaSettings.forEach((item: ICardAreaSettings) => {
          if (item.cardIndex === i) {
            if (item.row) {
              this.elementRef.nativeElement.children[i].style.setProperty('--row', item.row);
            }

            if (item.column) {
              this.elementRef.nativeElement.children[i].style.setProperty('--column', item.column);
            }
          }
        });
      }
    }
  }

  private cleanGridSettings(): void {
    for (let i = 0; i < this.elementRef.nativeElement.children.length; i++) {
      this.elementRef.nativeElement.children[i].style.setProperty('--row', 'auto');
      this.elementRef.nativeElement.children[i].style.setProperty('--column', 'auto');
    }
  }
}
